// extracted by mini-css-extract-plugin
export var acitonButtons = "_g3-0";
export var additionalIcon = "_g3-f";
export var block = "_g3-1";
export var blockContent = "_g3-7";
export var blockDescription = "_g3-8";
export var blockIcon = "_g3-9";
export var blockTitle = "_g3-6";
export var border = "_g3-a";
export var center = "_g3-l";
export var edge = "_g3-b";
export var edgeLabel = "_g3-c";
export var edgePath = "_g3-d";
export var error = "_g3-e";
export var flowchart = "_g3-g";
export var flowchartContent = "_g3-h";
export var highlighted = "_g3-3";
export var hover = "_g3-4";
export var icon = "_g3-i";
export var left = "_g3-m";
export var navButton = "_g3-j";
export var navButtons = "_g3-k";
export var right = "_g3-n";
export var selected = "_g3-2";
export var small = "_g3-5";